import {otsBaseApi} from "../ots-api";
import {removeUndefined} from "../../util/util";
import {RouteResult} from "../../model/routing/route-result";
import {LatLng} from "../../model/routing/lat-lng";
import {OriginManyRouteResult} from "../../model/routing/origin-many-route-result";

const ALL_TAG_TYPES = [
  "Routing",
] as const;

type TagType = typeof ALL_TAG_TYPES[number];

const taggedBaseApi = otsBaseApi.enhanceEndpoints({
  addTagTypes: ALL_TAG_TYPES
});

const routingApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRoutingResult: builder.query<RouteResult, GetRouteArgs>({
      query: ({origin, destination, includePath = true, includeEncodedPolyline = true}) => ({
        url: `/routing`,
        method: "GET",
        params: removeUndefined({
          origin: toLatLngParam(origin),
          destination: toLatLngParam(destination),
          includePath,
          includeEncodedPolyline,
        })
      }),
      providesTags: (_res, _err, args) => [
        {type: 'Routing', id: `${args.origin.lat},${args.origin.lon}->${args.destination.lat},${args.destination.lon}`},
      ],
    }),
    getRoutingOriginManyResult: builder.query<OriginManyRouteResult, GetOriginManyRouteArgs>({
      query: (arg) => ({
        url: `/routing/origin-many`,
        method: "POST",
        body: arg
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.results.map(({destination}) => ({
              type: "Routing",
              id: `${result.origin.lat},${result.origin.lon}->${destination.lat},${destination.lon}`
            } as const)),
          ];
        } else {
          return [];
        }
      }
    }),
  })
});

type GetRouteArgs = {
  origin: LatLng;
  destination: LatLng;
  includePath?: boolean;
  includeEncodedPolyline?: boolean;
};

type GetOriginManyRouteArgs = {
  origin: LatLng;
  destinations: LatLng[];
  includePath?: boolean;
  includeEncodedPolyline?: boolean;
};

const toLatLngParam = (p: LatLng) => `${p.lat},${p.lon}`;

export const {
  useGetRoutingResultQuery,
  useLazyGetRoutingResultQuery,
  useGetRoutingOriginManyResultQuery,
  useLazyGetRoutingOriginManyResultQuery,
} = routingApi;
